import GenericForm from "Admin/components/GenericForm";

function CreateServicosProdutos() {
  return (
    <GenericForm
      title="Cadastro de Serviço/Produto"
      description="Preencha as informações do serviço ou produto"
      endpoint="/novoservprod"
      fields={[
        { name: "Informações", label: "informações gerais", type: "title", default: true },
        { name: "codigo", label: "Código", type: "text", required: true },
        { name: "nome", label: "Nome", type: "text", required: true },
        { name: "tipo", label: "Tipo", type: "select", options: [
          { label: 'Serviço', value: 'servico' },
          { label: 'Produto', value: 'produto' }
        ], required: true },
        { name: "preco_venda", label: "Preço de Venda", type: "number", step: "0.01", required: true },
        { name: "status", label: "Status", type: "checkbox", default: true },

        { name: "Especificações", label: "especificações e detalhes", type: "title", default: true },
        { name: "custo", label: "Custo", type: "number", step: "0.01", default: 0 },
        { name: "liquido", label: "Preço Líquido", type: "number", step: "0.01", default: 0 },
        
        { name: "Para Produtos", label: "especificações e detalhes de produtos", type: "title", default: true },
        { name: "unidade_medida", label: "Unidade de Medida", type: "text" },
        { name: "estoque_minimo", label: "Estoque Mínimo", type: "number", required: false },
        { name: "estoque_atual", label: "Estoque Atual", type: "number", required: false },
        { name: "controla_estoque", label: "Controla Estoque?", type: "checkbox", default: false },
       
        { name: "Para Serviços", label: "especificações e detalhes de serviços", type: "title", default: true },
        { name: "previsao_retorno", label: "Previsão de Retorno", type: "date" },
        
      ]}
    />
  );
}

export default CreateServicosProdutos;
